import get from 'lodash/get';
import configureStore from 'src/common/store/configureStore';
import { isDevBuild } from 'src/common/utils/environment';
import apiClientEffectsMiddleware from 'src/common/middleware/apiClientEffects';
import createTunerMiddleware from '../middleware/tuner';
import unauthenticateMiddleware from '../middleware/unauthenticate';
import captureReduxError from '../utils/captureReduxError';
import apiClientEffectsErrorCallback from '../utils/apiClientEffectsErrorCallback';
import pageTrackingMiddleware from '../middleware/pageTrackingMiddleware';
import logActivity from '../middleware/loggingMiddleware';
import refreshNowPlayingMiddleware from '../middleware/refreshNowPlayingMiddleware';
import executeActionNeedingAuth from '../middleware/executeActionNeedingAuth';
import logInfo from '../middleware/logInfo';
import dialogMiddleware from '../middleware/dialogMiddleware';
import popoutPlayerMiddleware from '../middleware/popoutPlayerMiddleware';

export default function configureClientStore(
  initialState,
  history,
  tuneInApiClient,
) {
  const envMiddleware = [
    createTunerMiddleware,
    unauthenticateMiddleware,
    pageTrackingMiddleware,
    logActivity,
    refreshNowPlayingMiddleware,
    executeActionNeedingAuth,
    dialogMiddleware,
    logInfo,
    popoutPlayerMiddleware,
  ];

  if (isDevBuild()) {
    // use require since redux-logger won't be included in production scripts
    // eslint-disable-next-line global-require
    const createLogger = require('redux-logger');

    envMiddleware.push(
      createLogger({
        collapsed: true,
        // predicate determines whether or not to log actions to the console
        // see window.tiDebug (defined in client/index.js)
        predicate: (getState) =>
          get(getState(), 'app.debug.showActionLogs', true),
      }),
    );
  }

  return configureStore(
    initialState,
    envMiddleware,
    apiClientEffectsMiddleware(tuneInApiClient, apiClientEffectsErrorCallback),
    captureReduxError,
  );
}
